import Component_Click_eef014a031bba3e26b8b04f227164c8f from "../../../../content/examples/hooks/click/Click";
import Devtool_Click_eef014a031bba3e26b8b04f227164c8f from "!!@devtool/loader!../../../../content/examples/hooks/click/Click";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_Click_eef014a031bba3e26b8b04f227164c8f,
  Devtool_Click_eef014a031bba3e26b8b04f227164c8f,
  DevTool,
  React
};